module.exports = __webpack_public_path__ + "static/2011-port-a43ca30604aba5069f403c1720f08d38.jpg";